export default {
  'goldkid-blank:title': 'Данные вашего ребенка:',
  'goldkid-blank:iin': 'ИИН ребенка',
  'goldkid-blank:no-iin': 'Нет ИИН ребенка?',
  'goldkid-blank:iin-required': 'Укажите ИИН',
  'goldkid-blank:invalid-iin': 'ИИН ребенка введён некорректно',
  'goldkid-blank:phone': 'Мобильный телефон ребенка',
  'goldkid-blank:phone-required': 'Введите номер мобильного ребенка',
  'goldkid-blank:phone-length': 'Номер телефона введен некорректно',
  'goldkid-blank:phone-operator': 'Номер не принадлежит ни одному оператору РК',
  'goldkid-blank:phone-number': 'Необходимо ввести другой номер мобильного телефона',
  'goldkid-blank:phone-note': 'Мы отправим SMS-код на номер вашего ребенка',
  'goldkid-blank:btn': 'Подтвердить номер ребенка',
  'goldkid-blank:confirm-doc': 'Нажимая на кнопку, Вы подтверждаете, что ознакомлены <a class="text-action-link underline">с&nbsp;заявлением на оформление Kaspi&nbsp;Gold</a>',
  'goldkid-blank:title-name': 'Укажите номер телефона {0}',
  'goldkid-blank:title-description': 'Номер телефона нужен, чтобы ребенок смог войти в приложение Kaspi.kz'
}
